module.exports = __webpack_public_path__ + "img/fi-rr-poker-chip.bf4e8231.svg";